import { render, staticRenderFns } from "./TariffFormDialog.vue?vue&type=template&id=6c82ee72&"
import script from "./TariffFormDialog.vue?vue&type=script&lang=ts&"
export * from "./TariffFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports